var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "30%",
            "show-close": true
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("table", [
            _c("tr", [
              _c("td", [
                _c("div", { staticStyle: { float: "left" } }, [
                  _c("h1", [_vm._v(_vm._s(_vm.translateWords.title))])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      staticClass: "demo-ruleForm",
                      attrs: {
                        model: _vm.ruleForm,
                        rules: _vm.rules,
                        "label-width": "200x"
                      }
                    },
                    [
                      _c("table", [
                        _c("tr", [
                          _c(
                            "td",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.translateWords.PositionName,
                                    prop: "PositionName"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.ruleForm.PositionName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "PositionName",
                                          $$v
                                        )
                                      },
                                      expression: "ruleForm.PositionName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c(
                            "td",
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.translateWords.Status,
                                    prop: "Status"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "400px" },
                                      attrs: {
                                        placeholder:
                                          _vm.translateWords.statusText,
                                        filterable: ""
                                      },
                                      model: {
                                        value: _vm.ruleForm.Status,
                                        callback: function($$v) {
                                          _vm.$set(_vm.ruleForm, "Status", $$v)
                                        },
                                        expression: "ruleForm.Status"
                                      }
                                    },
                                    _vm._l(
                                      _vm.AddPositionStatusDropList,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c(
                            "td",
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "300px" },
                                  attrs: {
                                    label: _vm.translateWords.IsUseRegion,
                                    prop: "IsUseRegion"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "300px" },
                                      attrs: {
                                        placeholder:
                                          _vm.translateWords.selectText,
                                        filterable: ""
                                      },
                                      model: {
                                        value: _vm.ruleForm.IsUseRegion,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "IsUseRegion",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.IsUseRegion"
                                      }
                                    },
                                    _vm._l(_vm.AddIsUseRegionDropList, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c(
                            "td",
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { width: "300px" },
                                  attrs: {
                                    label: _vm.translateWords.RegionName,
                                    prop: "RegionId"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "300px" },
                                      attrs: {
                                        placeholder:
                                          _vm.translateWords.regionText,
                                        filterable: ""
                                      },
                                      model: {
                                        value: _vm.ruleForm.RegionId,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "RegionId",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.RegionId"
                                      }
                                    },
                                    _vm._l(_vm.AddRegionNameDropList, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { staticStyle: { float: "left" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.submitForm("ruleForm")
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.translateWords.Save))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("table", { staticStyle: { width: "90%" } }, [
        _c("tr", [
          _c("td", [
            _c("div", { staticStyle: { float: "left" } }, [
              _c("h1", [_vm._v(_vm._s(_vm.translateWords.PostionManage))])
            ])
          ]),
          _vm._v(" "),
          _c("td")
        ]),
        _vm._v(" "),
        _c("tr", [
          _c(
            "td",
            [
              _vm._v(
                "\n         " + _vm._s(_vm.translateWords.DepartmentName) + "："
              ),
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.translateWords.DepartmentName },
                  model: {
                    value: _vm.PositionQuery.DepartMentID,
                    callback: function($$v) {
                      _vm.$set(_vm.PositionQuery, "DepartMentID", $$v)
                    },
                    expression: "PositionQuery.DepartMentID"
                  }
                },
                _vm._l(_vm.DepartmentDropList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "td",
            [
              _vm._v(
                "\n         " + _vm._s(_vm.translateWords.PositionName) + "："
              ),
              _c("el-input", {
                staticStyle: { width: "301px" },
                attrs: { placeholder: _vm.translateWords.PositionName },
                model: {
                  value: _vm.PositionQuery.PositionName,
                  callback: function($$v) {
                    _vm.$set(_vm.PositionQuery, "PositionName", $$v)
                  },
                  expression: "PositionQuery.PositionName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "td",
            [
              _vm._v(
                "\n         " + _vm._s(_vm.translateWords.RegionName) + "："
              ),
              _c(
                "el-select",
                {
                  staticStyle: { width: "300x" },
                  attrs: { placeholder: _vm.translateWords.regionText },
                  model: {
                    value: _vm.PositionQuery.RegionId,
                    callback: function($$v) {
                      _vm.$set(_vm.PositionQuery, "RegionId", $$v)
                    },
                    expression: "PositionQuery.RegionId"
                  }
                },
                _vm._l(_vm.RegionNameDropList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("tr", [
          _c(
            "td",
            [
              _vm._v("\n         " + _vm._s(_vm.translateWords.Status) + "："),
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.translateWords.Status },
                  model: {
                    value: _vm.PositionQuery.Status,
                    callback: function($$v) {
                      _vm.$set(_vm.PositionQuery, "Status", $$v)
                    },
                    expression: "PositionQuery.Status"
                  }
                },
                _vm._l(_vm.PositionStatusDropList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "td",
            [
              _vm._v(
                "\n         " + _vm._s(_vm.translateWords.RegionStatus) + "："
              ),
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.translateWords.RegionStatus },
                  model: {
                    value: _vm.PositionQuery.RegionStatus,
                    callback: function($$v) {
                      _vm.$set(_vm.PositionQuery, "RegionStatus", $$v)
                    },
                    expression: "PositionQuery.RegionStatus"
                  }
                },
                _vm._l(_vm.RegionStatusDropList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "td",
            [
              _vm.PermissonList.Search.value
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.query } },
                    [_vm._v(_vm._s(_vm.translateWords.query))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.PermissonList.Add.value
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.add } },
                    [_vm._v(_vm._s(_vm.translateWords.add))]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        { staticStyle: { width: "90%" }, attrs: { data: _vm.tableData } },
        [
          _c("el-table-column", {
            attrs: { prop: "Id", label: _vm.translateWords.Code, width: "101" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "DepartmentName",
              label: _vm.translateWords.DepartmentName
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "PositionName",
              label: _vm.translateWords.PositionName
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "RegionName", label: _vm.translateWords.RegionName }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "IsUseRegion",
              label: _vm.translateWords.IsUseRegion,
              width: "201"
            }
          }),
          _vm._v(" "),
          false
            ? _c("el-table-column", {
                attrs: {
                  prop: "IsUseRegionCode",
                  label: _vm.translateWords.IsUseRegion
                }
              })
            : _vm._e(),
          _vm._v(" "),
          false
            ? _c("el-table-column", {
                attrs: {
                  prop: "RegionId",
                  width: "10",
                  label: _vm.translateWords.RegionName
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "Status",
              width: "200",
              label: _vm.translateWords.Status
            }
          }),
          _vm._v(" "),
          false
            ? _c("el-table-column", {
                attrs: { prop: "StatusCode", label: _vm.translateWords.Status }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: _vm.translateWords.operate },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.PermissonList.Update.value
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.handleEdit(scope.$index, scope.row)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.translateWords.edit))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.PermissonList.Delete.value
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.handleDelete(scope.$index, scope.row)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.translateWords.delete))]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        attrs: {
          "current-page": 1,
          "page-sizes": [10, 20, 30],
          "page-size": 10,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29d7fcd9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29d7fcd9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Position.vue
// module id = null
// module chunks = 